<template>
  <div class="container-list">
    <!-- <div class="container-detail"> -->
    <div class="text-h4 font-weight-medium text-title text-uppercase">
      Proyectos
    </div>
    <br />
    <div class="list-container">
      <p v-if="projects === null" class="infos-label">Cargando...</p>
      <p v-if="projects && !projects.length" class="infos-label">
        No existen proyectos registrados
      </p>
      <ProyectoCatalogo
        v-for="(product, index) in projects"
        :key="product.id"
        :index="index"
        class="ma-2 item-project"
        :disable-actions="!networkOnLine"
        :data="product"
        @deleteProduct="deleteUserProduct"
      ></ProyectoCatalogo>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import ProyectoCatalogo from '@/components/normal/ProyectoCatalogo'
import { mapState, mapActions } from 'vuex'

export default {
  components: { ProyectoCatalogo },
  computed: {
    ...mapState('projectsRoot', ['projects']),
    ...mapState('app', ['networkOnLine'])
  },
  methods: {
    ...mapActions('projectsRoot', ['deleteUserProduct'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.container-list {
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: rgba(194, 194, 194, 0.611);
  margin-bottom: 100px;

  padding-top: 30px;
  padding-bottom: 30px;
}

// .container-detail {
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-start;
//   align-items: flex-start;
// }

.list-container {
  // width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
}

.item-project {
  max-width: 400px;
}

.text-title {
  text-align: left;
}

@media (max-width: 960px) and (min-width: 600px) {
  .text-title {
    text-align: center;
  }
}

@media (max-width: 600px) {
  .text-title {
    text-align: center;
  }
}
</style>
